import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Floor from './floors/Floor';

const FloorPlan = ({
  scale,
  desktop,
  backgroundColor,
  eighthFloorRooms,
  ninthFloorRooms,
  tenthFloorRooms,
}) => {

  return (
    <Routes>
      <Route
        path=":floorNumber"
        element={
          <Floor
            scale={scale}
            desktop={desktop}
            backgroundColor={backgroundColor}
            eighthFloorRooms={eighthFloorRooms}
            ninthFloorRooms={ninthFloorRooms}
            tenthFloorRooms={tenthFloorRooms}
          />
        }
      />
      <Route path="*" element={<Navigate to="8" replace />} />
    </Routes>
  );
};

export default FloorPlan;